import { type FC } from "react";

import { faFileDownload } from "@fortawesome/pro-duotone-svg-icons/faFileDownload";
import { faTriangleExclamation } from "@fortawesome/pro-duotone-svg-icons/faTriangleExclamation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { track } from "@application/utilities/track";

import { Button } from "@styled/button";
import { ButtonAnchor } from "@styled/button_anchor";
import { PillGroup, PillLabel } from "@styled/pill_group";
import { ScreenReaderStatus } from "@styled/screen_reader_status";

import { useDraftDownload } from "./use_draft_download";

// The draft he uploaded, as uploaded.
export const TemplateDownload: FC<{ url: string; projectId: string }> = ({
  url,
  projectId,
}) => (
  <PillGroup phone="icons">
    <ButtonAnchor
      color="white"
      size="sm"
      href={url}
      download
      aria-label="Download the template you uploaded"
      onClick={() =>
        track("document_downloaded", {
          project_id: projectId,
          kind: "drafting_template",
        })
      }
    >
      <FontAwesomeIcon icon={faFileDownload} />
      <PillLabel>Download</PillLabel>
    </ButtonAnchor>
  </PillGroup>
);

// His Word file with the sections typed in, built on the click: the pane's
// main action over the Report. Before any chat, the case's with his edits.
export const ReportDownload: FC<{
  conversationId?: string;
  projectId: string;
}> = ({ conversationId, projectId }) => {
  const { download, downloading, failed } = useDraftDownload({
    conversationId,
    projectId,
  });

  return (
    <>
      {/* Solid, so outside a pill group, which would drop its fill. */}
      <Button
        type="button"
        color="navy"
        size="sm"
        disabled={downloading}
        onClick={() => void download()}
        aria-label={
          failed
            ? "Couldn't download your report. Try again"
            : "Download your report with the sections in (Word)"
        }
      >
        <FontAwesomeIcon
          icon={failed ? faTriangleExclamation : faFileDownload}
        />
        {failed ? "Couldn't download · Try again" : "Download report"}
      </Button>
      <ScreenReaderStatus>
        {failed ? "Couldn't download your report. Try again." : null}
      </ScreenReaderStatus>
    </>
  );
};
